import React from 'react';
import { Facebook, Github, Linkedin, Mail, Phone, Twitter } from 'lucide-react';

export const Footer = ({ translations, isDark }) => {
  return (
    <footer className={`border-t-2 transition-colors duration-300 ${
      isDark ? 'bg-zinc-950 border-zinc-800' : 'bg-white border-zinc-200'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          <div className="flex items-center space-x-2">
            <div className={`w-10 h-10 flex items-center justify-center ${
              isDark ? 'bg-cyan-400' : 'bg-cyan-500'
            }`}>
              <span className={`font-bold text-2xl ${
                isDark ? 'text-black' : 'text-white'
              }`}>A</span>
            </div>
            <span className={`font-bold text-2xl tracking-tight ${
              isDark ? 'text-white' : 'text-zinc-900'
            }`}>AS COM</span>
          </div>

          <div className="text-center">
            <p className={`text-sm ${
              isDark ? 'text-zinc-500' : 'text-zinc-600'
            }`}>{translations.footer.rights}</p>
          </div>

          <div className="flex justify-end space-x-4">
            <a
              href="#"
              className={`w-10 h-10 border-2 flex items-center justify-center transition-all duration-200 ${
                isDark 
                  ? 'bg-zinc-900 border-zinc-800 hover:border-cyan-400 hover:bg-zinc-800'
                  : 'bg-zinc-50 border-zinc-200 hover:border-cyan-500 hover:bg-zinc-100'
              }`}
              aria-label="Github"
            >
              <Facebook className={`w-5 h-5 ${
                isDark 
                  ? 'text-zinc-400 hover:text-cyan-400'
                  : 'text-zinc-600 hover:text-cyan-600'
              }`} />
            </a>
            <a
              href="tel:+48602729781"
              className={`w-10 h-10 border-2 flex items-center justify-center transition-all duration-200 ${
                isDark 
                  ? 'bg-zinc-900 border-zinc-800 hover:border-cyan-400 hover:bg-zinc-800'
                  : 'bg-zinc-50 border-zinc-200 hover:border-cyan-500 hover:bg-zinc-100'
              }`}
              aria-label="LinkedIn"
            >
              <Phone className={`w-5 h-5 ${
                isDark 
                  ? 'text-zinc-400 hover:text-cyan-400'
                  : 'text-zinc-600 hover:text-cyan-600'
              }`} />
            </a>
            <a
              href="mailto:service@ascom-sultions.com"
              className={`w-10 h-10 border-2 flex items-center justify-center transition-all duration-200 ${
                isDark 
                  ? 'bg-zinc-900 border-zinc-800 hover:border-cyan-400 hover:bg-zinc-800'
                  : 'bg-zinc-50 border-zinc-200 hover:border-cyan-500 hover:bg-zinc-100'
              }`}
              aria-label="Twitter"
            >
              <Mail className={`w-5 h-5 ${
                isDark 
                  ? 'text-zinc-400 hover:text-cyan-400'
                  : 'text-zinc-600 hover:text-cyan-600'
              }`} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};